export default {
  routerList: [
    {
      path: "/pages/Demo",
      name: "Demo",
      component: (resolve) =>
        require(["@/pages/a_Demo/Demo/"], (comp) =>
          resolve({
            ...comp.default,
            name: "Demo",
          })),
      meta: {
        title: "模板页",
        keepAlive: true,
      },
    },
    //========业务订单========
    {
      path: "/WaybillManage/ComprehensiveQuery",
      name: "ComprehensiveQuery",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/ComprehensiveQuery"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "ComprehensiveQuery",
          })),
      meta: {
        title: "全部运单",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/waybillLogList",
      name: "waybillLogList",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/waybillLogList"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "waybillLogList",
          })),
      meta: {
        title: "运单操作日志",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillCreate",
      name: "WaybillCreate",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCreate"], (comp) =>
          resolve({
            ...comp.default,
            name: "WaybillCreate",
          })),
      meta: {
        title: "新建运单",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillCreateRX",
      name: "WaybillCreateRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCreateRX"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "WaybillCreateRX",
          })),
      meta: {
        title: "新建运单",
        keepAlive: true,
      },
      props({ query: { commandIds, waybillSplitId, isSee, type } }) {
        return { commandIds, waybillSplitId, isSee, type };
      },
    },
    {
      path: "/WaybillManage/WaybillEdit",
      name: "WaybillEdit",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillEdit"], (comp) =>
          resolve({
            ...comp.default,
            name: "WaybillEdit",
          })),
      meta: {
        title: "修改运单",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillEditRX",
      name: "WaybillEditRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCreateRX"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "WaybillEditRX",
          })),
      meta: {
        title: "修改运单",
        keepAlive: true,
      },
      props({ query: { commandIds, waybillSplitId, isSee, type } }) {
        return { commandIds, waybillSplitId, isSee, type: "edit" };
      },
    },
    {
      path: "/WaybillManage/WaybillTranformRX",
      name: "WaybillTranformRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCreateRX"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "WaybillTranformRX",
          })),
      meta: {
        title: "转为运单",
        keepAlive: true,
      },
      props({ query: { commandIds, waybillSplitId, isSee, type } }) {
        return {
          commandIds,
          waybillSplitId,
          isSee,
          type: "transferFromCommand",
        };
      },
    },
    {
      path: "/WaybillManage/WaybillBaseEditRX",
      name: "WaybillBaseEditRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCreateRX"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "WaybillBaseEditRX",
          })),
      meta: {
        title: "修改基本信息",
        keepAlive: true,
      },
      props({ query: { commandIds, waybillSplitId, isSee, type } }) {
        return { commandIds, waybillSplitId, isSee, type: "baseEdit" };
      },
    },
    {
      path: "/WaybillManage/WaybillFeeCheckInRX",
      name: "WaybillFeeCheckInRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCreateRX"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "WaybillFeeCheckInRX",
          })),
      meta: {
        title: "费用录入",
        keepAlive: true,
      },
      props({ query: { commandIds, waybillSplitId, isSee, type } }) {
        return { commandIds, waybillSplitId, isSee, type: "feeCheckIn" };
      },
    },
    {
      path: "/WaybillManage/WaybillCaiWuRuLuRX",
      name: "WaybillCaiWuRuLuRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCaiWuRuLuRX"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "WaybillCaiWuRuLuRX",
          })),
      meta: {
        title: "费用录入",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillCopyRX",
      name: "WaybillCopyRX",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillCreateRX"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "WaybillCopyRX",
          })),
      meta: {
        title: "复制新增",
        keepAlive: true,
      },
      props({ query: { commandIds, waybillSplitId, isSee, type } }) {
        return { commandIds, waybillSplitId, isSee, type: "copy" };
      },
    },
    {
      path: "/WaybillManage/sumAll/ComprehensiveQuerySumAll",
      name: "ComprehensiveQuerySumAll",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/sumAll/ComprehensiveQuerySumAll",
        ], (comp) =>
          resolve({
            ...comp.default,
            name: "ComprehensiveQuerySumAll",
          })),
      meta: {
        title: "运单综合查询",
        keepAlive: true,
      },
      props({ query: { waybillNumber } }) {
        return { waybillNumber };
      },
    },
    {
      path: "/WaybillManage/WaybillPostingRX",
      name: "WaybillPostingRX",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/WaybillPostingRX/WaybillPostingRX",
        ], (comp) =>
          resolve({
            ...comp.default,
            name: "WaybillPostingRX",
          })),
      meta: {
        title: "运单过账",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/financeIn/List",
      name: "FinanceInList",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/financeIn/List"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "FinanceInList",
          })),
      meta: {
        title: "运单应收过账",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/financeOut/List",
      name: "FinanceOut",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/financeOut/List"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "FinanceOut",
          })),
      meta: {
        title: "运单应付过账",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/financeOther/List",
      name: "FinanceOther",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/financeOther/List"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "FinanceOther",
          })),
      meta: {
        title: "运单其他收入过账",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/TrackingWaybill",
      name: "TrackingWaybill",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/TrackingWaybill"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "TrackingWaybill",
          })),
      meta: {
        title: "运单跟踪",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/TrackingWaybillAddy",
      name: "TrackingWaybillAddy",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/TrackingWaybillAddy"], (
          comp
        ) =>
          resolve({
            ...comp.default,
            name: "TrackingWaybillAddy",
          })),
      meta: {
        title: "跟踪录入",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillDetails",
      name: "WaybillDetails",
      component: (resolve) =>
        require([
          "@/pages/BusinessOrder/WaybillManage/sumAll/ComprehensiveQuerySumAll",
        ], (comp) =>
          resolve({
            ...comp.default,
            name: "ComprehensiveQuerySumAll",
          })),
      meta: {
        title: "运单详情",
        keepAlive: true,
      },
      props({ query: { waybillNumber, waybillSplitId, orderNumber } }) {
        return { waybillNumber, waybillSplitId, orderNumber };
      },
    },
    {
      path: "/WaybillManage/sign/sign",
      name: "WaybillSigne",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/sign/sign"], (comp) =>
          resolve({ ...comp.default, name: "WaybillSigne" })),
      meta: {
        title: "运单签收",
        keepAlive: true,
      },
      props({ query: { dispatchId } }) {
        return { dispatchId };
      },
    },
    {
      path: "/WaybillManage/Waybillimport",
      name: "Waybillimport",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/Waybillimport"], (comp) =>
          resolve({ ...comp.default, name: "Waybillimport" })),
      meta: {
        title: "运单导入",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/WaybillimportDetail",
      name: "WaybillimportDetail",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/WaybillimportDetail"], (
          comp
        ) => resolve({ ...comp.default, name: "WaybillimportDetail" })),
      meta: {
        title: "导入预览",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/Posting",
      name: "Posting",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/Posting"], (comp) =>
          resolve({ ...comp.default, name: "Posting" })),
      meta: {
        title: "过账",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/TransportationPlann",
      name: "TransportationPlann",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/TransportationPlann"], (
          comp
        ) => resolve({ ...comp.default, name: "TransportationPlann" })),
      meta: {
        title: "运单运输规划",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/SplitOrder",
      name: "SplitOrder",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/SplitOrder"], (comp) =>
          resolve({ ...comp.default, name: "SplitOrder" })),
      meta: {
        title: "拆单",
        keepAlive: true,
      },
    },
    {
      path: "/WaybillManage/TestPage",
      name: "TestPage",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/TestPage"], (comp) =>
          resolve({ ...comp.default, name: "TestPage" })),
      meta: {
        title: "动态查询",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/OutgoingManage",
      name: "OutgoingManage",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/OutgoingManage/OutgoingManage"], (
          comp
        ) => resolve({ ...comp.default, name: "OutgoingManage" })),
      meta: {
        title: "外发列表",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/OutgoingAdd",
      name: "OutgoingAdd",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/OutgoingManage/OutgoingAdd"], (comp) =>
          resolve({ ...comp.default, name: "OutgoingAdd" })),
      meta: {
        title: "新建外发",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/OutgoingEdit",
      name: "OutgoingEdit",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/OutgoingManage/OutgoingEdit"], (comp) =>
          resolve({ ...comp.default, name: "OutgoingEdit" })),
      meta: {
        title: "修改外发",
        keepAlive: true,
      },
    },
    {
      path: "/OutgoingManage/OutgoingPosting",
      name: "OutgoingPosting",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/OutgoingManage/OutgoingPosting"], (
          comp
        ) => resolve({ ...comp.default, name: "OutgoingPosting" })),
      meta: {
        title: "外发过账",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionManage",
      name: "ExceptionManage",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/ExceptionManage/ExceptionManage"], (
          comp
        ) => resolve({ ...comp.default, name: "ExceptionManage" })),
      meta: {
        title: "异常列表",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionAdd",
      name: "ExceptionAdd",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/ExceptionManage/ExceptionAdd"], (
          comp
        ) => resolve({ ...comp.default, name: "ExceptionAdd" })),
      meta: {
        title: "新建异常",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionModify",
      name: "ExceptionModify",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/ExceptionManage/ExceptionModify"], (
          comp
        ) => resolve({ ...comp.default, name: "ExceptionModify" })),
      meta: {
        title: "修改异常",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionEdit",
      name: "ExceptionEdit",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/ExceptionManage/ExceptionEdit"], (
          comp
        ) => resolve({ ...comp.default, name: "ExceptionEdit" })),
      meta: {
        title: "跟进异常",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionDetils",
      name: "ExceptionDetils",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/ExceptionManage/ExceptionDetils"], (
          comp
        ) => resolve({ ...comp.default, name: "ExceptionDetils" })),
      meta: {
        title: "异常详情",
        keepAlive: true,
      },
    },
    {
      path: "/ExceptionManage/ExceptionHeDing",
      name: "ExceptionHeDing",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/ExceptionManage/ExceptionHeDing"], (
          comp
        ) => resolve({ ...comp.default, name: "ExceptionHeDing" })),
      meta: {
        title: "责任核定",
        keepAlive: true,
      },
    },
    {
      path: "/BusinessOrder/DeliveryNotice",
      name: "DeliveryNotice",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/DeliveryNotice"], (comp) =>
          resolve({ ...comp.default, name: "DeliveryNotice" })),
      meta: {
        title: "到货通知",
        keepAlive: true,
      },
    },
    {
      path: "/BusinessOrder/ReceiptManage",
      name: "ReceiptManage",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/ReceiptManage"], (comp) =>
          resolve({ ...comp.default, name: "ReceiptManage" })),
      meta: {
        title: "回单管理",
        keepAlive: true,
      },
    },

    // 系统设置=>基础设置
    {
      path: "/SystemSetting/RegionalMaintenance",
      name: "RegionalMaintenance",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/RegionalMaintenance"], (
          comp
        ) => resolve({ ...comp.default, name: "RegionalMaintenance" })),
      meta: {
        title: "地区维护",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/organizationalStructure",
      name: "organizationalStructure",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/organizationalStructure",
        ], (comp) =>
          resolve({ ...comp.default, name: "organizationalStructure" })),
      meta: {
        title: "组织架构",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/ArticleManagement",
      name: "ArticleManagement",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/ArticleManagement/ArticleManagement",
        ], (comp) => resolve({ ...comp.default, name: "ArticleManagement" })),
      meta: {
        title: "文章管理",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/AddSystemArticle",
      name: "AddSystemArticle",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/ArticleManagement/AddSystemArticle",
        ], (comp) => resolve({ ...comp.default, name: "AddSystemArticle" })),
      meta: {
        title: "新建文章",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/AppVersionManagement",
      name: "AppVersionManagement",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/AppVersionManagement"], (
          comp
        ) => resolve({ ...comp.default, name: "AppVersionManagement" })),
      meta: {
        title: "app版本管理",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/SystemVISettings",
      name: "SystemVISettings",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/SystemVISettings"], (
          comp
        ) => resolve({ ...comp.default, name: "SystemVISettings" })),
      meta: {
        title: "系统VI设置",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/GoodsCategoryType",
      name: "GoodsCategoryType",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/GoodsCategoryType"], (
          comp
        ) => resolve({ ...comp.default, name: "GoodsCategoryType" })),
      meta: {
        title: "货物品类类型",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/GoodsCategory",
      name: "GoodsCategory",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/GoodsCategory"], (comp) =>
          resolve({ ...comp.default, name: "GoodsCategory" })),
      meta: {
        title: "货物品类",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/CargoMaintenance",
      name: "CargoMaintenance",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/CargoMaintenance"], (
          comp
        ) => resolve({ ...comp.default, name: "CargoMaintenance" })),
      meta: {
        title: "货物维护",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/RoleManagement",
      name: "RoleManagement",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/RoleManagement"], (comp) =>
          resolve({ ...comp.default, name: "RoleManagement" })),
      meta: {
        title: "角色管理",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/EmployeeManagement",
      name: "EmployeeManagement",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/EmployeeManagement"], (
          comp
        ) => resolve({ ...comp.default, name: "EmployeeManagement" })),
      meta: {
        title: "员工管理",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/OperationLog",
      name: "OperationLog",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/OperationLog"], (comp) =>
          resolve({ ...comp.default, name: "OperationLog" })),
      meta: {
        title: "操作日志",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/DataDictionary",
      name: "DataDictionary",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/DataDictionary"], (comp) =>
          resolve({ ...comp.default, name: "DataDictionary" })),
      meta: {
        title: "数据字典",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/AccountManagement",
      name: "AccountManagement",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/AccountManagement/AccountManagement",
        ], (comp) => resolve({ ...comp.default, name: "AccountManagement" })),
      meta: {
        title: "账号管理",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/PermissionAssignmentUser",
      name: "PermissionAssignmentUser",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/AccountManagement/PermissionAssignmentUser",
        ], (comp) =>
          resolve({ ...comp.default, name: "PermissionAssignmentUser" })),
      meta: {
        title: "账号权限分配",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/PermissionAssignmentRole",
      name: "PermissionAssignmentRole",
      component: (resolve) =>
        require([
          "@/pages/SystemSetting/BasicSetting/AccountManagement/PermissionAssignmentRole",
        ], (comp) =>
          resolve({ ...comp.default, name: "PermissionAssignmentRole" })),
      meta: {
        title: "角色权限分配",
        keepAlive: true,
      },
    },
    {
      path: "/SystemSetting/LogoSettings",
      name: "LogoSettings",
      component: (resolve) =>
        require(["@/pages/SystemSetting/BasicSetting/LogoSettings"], (comp) =>
          resolve({ ...comp.default, name: "LogoSettings" })),
      meta: {
        title: "logo设置",
        keepAlive: true,
      },
    },

    // 调度派车模块
    {
      path: "/DispatchCar/TransportationPlann",
      name: "TransportationPlann",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/TransportationPlann/TransportationPlann",
        ], (comp) => resolve({ ...comp.default, name: "TransportationPlann" })),
      meta: {
        title: "运输任务",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/AddTransportationPlan",
      name: "AddTransportationPlan",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/TransportationPlann/AddTransportationPlan",
        ], (comp) =>
          resolve({ ...comp.default, name: "AddTransportationPlan" })),
      meta: {
        title: "运输规划",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/VehicleStowage",
      name: "VehicleStowage",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/VehicleStowage"], (comp) =>
          resolve({ ...comp.default, name: "VehicleStowage" })),
      meta: {
        title: "配载批次",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/TasksLoaded",
      name: "TasksLoaded",
      component: (resolve) =>
        require(["@/pages/DispatchCar/TasksLoaded/TasksLoaded"], (comp) =>
          resolve({ ...comp.default, name: "TasksLoaded" })),
      meta: {
        title: "待配载任务",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/TasksLoaded/NewBuiltStowage",
      name: "NewBuiltStowage",
      component: (resolve) =>
        require(["@/pages/DispatchCar/TasksLoaded/NewBuiltStowage"], (comp) =>
          resolve({ ...comp.default, name: "NewBuiltStowage" })),
      meta: {
        title: "新建配载任务",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/TasksLoaded/PreviewStowage",
      name: "PreviewStowage",
      component: (resolve) =>
        require(["@/pages/DispatchCar/TasksLoaded/PreviewStowage"], (comp) =>
          resolve({ ...comp.default, name: "PreviewStowage" })),
      meta: {
        title: "预览配载",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/TasksLoaded/BatchImport",
      name: "BatchImport",
      component: (resolve) =>
        require(["@/pages/DispatchCar/TasksLoaded/BatchImport"], (comp) =>
          resolve({ ...comp.default, name: "BatchImport" })),
      meta: {
        title: "配载批量导入",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/NewStowageAdd",
      name: "NewStowageAdd",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/NewStowageAdd"], (comp) =>
          resolve({ ...comp.default, name: "NewStowageAdd" })),
      meta: {
        title: "新建配载",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/NewStowageEdit",
      name: "NewStowageEdit",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/NewStowageEdit"], (comp) =>
          resolve({ ...comp.default, name: "NewStowageEdit" })),
      meta: {
        title: "修改配载",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/NewStowageEditRX",
      name: "NewStowageEditRX",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/NewStowageEditRX"], (
          comp
        ) => resolve({ ...comp.default, name: "NewStowageEditRX" })),
      meta: {
        title: "修改配载",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/FareAllocation",
      name: "FareAllocation",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/FareAllocation"], (comp) =>
          resolve({ ...comp.default, name: "FareAllocation" })),
      meta: {
        title: "车费分摊",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/RoyaltyApportionment",
      name: "RoyaltyApportionment",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/RoyaltyApportionment"], (
          comp
        ) => resolve({ ...comp.default, name: "RoyaltyApportionment" })),
      meta: {
        title: "提成分摊",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/dispatchCarDetails",
      name: "dispatchCarDetails",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/dispatchCarDetails"], (
          comp
        ) => resolve({ ...comp.default, name: "dispatchCarDetails" })),
      meta: {
        title: "发车详情",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/ChargebackAudit",
      name: "ChargebackAudit",
      component: (resolve) =>
        require(["@/pages/DispatchCar/ChargebackAudit/ChargebackAudit"], (
          comp
        ) => resolve({ ...comp.default, name: "ChargebackAudit" })),
      meta: {
        title: "退单审核",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/DepartureContractManagement",
      name: "DepartureContractManagement",
      component: (resolve) =>
        require([
          "@/pages/DispatchCar/DepartureContractManagement/DepartureContractManagement",
        ], (comp) =>
          resolve({ ...comp.default, name: "DepartureContractManagement" })),
      meta: {
        title: "发车合同管理",
        keepAlive: true,
      },
    },
    {
      path: "/DispatchCar/AdjustRoute",
      name: "AdjustRoute",
      component: (resolve) =>
        require(["@/pages/DispatchCar/VehicleStowage/AdjustRoute"], (comp) =>
          resolve({ ...comp.default, name: "AdjustRoute" })),
      meta: {
        title: "调整路线",
        keepAlive: true,
      },
    },
    // 仓库管理
    {
      path: "/WarehouseManagement/WaybillInventory",
      name: "WaybillInventory",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/WaybillInventory"], (comp) =>
          resolve({ ...comp.default, name: "WaybillInventory" })),
      meta: {
        title: "运单库存",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/InTransitWaybill",
      name: "InTransitWaybill",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/InTransitWaybill"], (comp) =>
          resolve({ ...comp.default, name: "InTransitWaybill" })),
      meta: {
        title: "在途运单",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/loadeUnloadeOrder",
      name: "loadeUnloadeOrder",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/loadeUnloadeOrder"], (comp) =>
          resolve({ ...comp.default, name: "loadeUnloadeOrder" })),
      meta: {
        title: "装卸单",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/loadeUnloadeOrderAdd",
      name: "loadeUnloadeOrderAdd",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/loadeUnloadeOrderAdd"], (comp) =>
          resolve({ ...comp.default, name: "loadeUnloadeOrderAdd" })),
      meta: {
        title: "新建装卸单",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/loadeUnloadeOrderEdit",
      name: "loadeUnloadeOrderEdit",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/loadeUnloadeOrderEdit"], (comp) =>
          resolve({ ...comp.default, name: "loadeUnloadeOrderEdit" })),
      meta: {
        title: "编辑装卸单",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/DeliveryConfirm",
      name: "DeliveryConfirm",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/DeliveryConfirm"], (comp) =>
          resolve({ ...comp.default, name: "DeliveryConfirm" })),
      meta: {
        title: "出库确认",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/WarehousingConfirm",
      name: "WarehousingConfirm",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/WarehousingConfirm"], (comp) =>
          resolve({ ...comp.default, name: "WarehousingConfirm" })),
      meta: {
        title: "入库确认",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/ReceiptIssueRecord",
      name: "ReceiptIssueRecord",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/ReceiptIssueRecord"], (comp) =>
          resolve({ ...comp.default, name: "ReceiptIssueRecord" })),
      meta: {
        title: "出入库记录",
        keepAlive: true,
      },
    },
    {
      path: "/WarehouseManagement/ReceiptIssueRecord",
      name: "ReceiptIssueRecord",
      component: (resolve) =>
        require(["@/pages/WarehouseManagement/ReceiptIssueRecord"], (comp) =>
          resolve({ ...comp.default, name: "ReceiptIssueRecord" })),
      meta: {
        title: "出入库记录",
        keepAlive: true,
      },
    },

    {
      path: "/message/messageList",
      name: "messageList",
      component: (resolve) =>
        require(["@/pages/message/messageList"], (comp) =>
          resolve({ ...comp.default, name: "messageList" })),
      meta: {
        title: "我的消息",
        keepAlive: true,
      },
    },
    {
      path: "/message/sysNoticeList",
      name: "SysNoticeList",
      component: (resolve) =>
        require(["@/pages/message/sysNotice/List"], (comp) =>
          resolve({ ...comp.default, name: "SysNoticeList" })),
      meta: {
        title: "系统公告",
        keepAlive: true,
      },
    },
    {
      path: "/message/noticeList",
      name: "NoticeList",
      component: (resolve) =>
        require(["@/pages/message/notice/List"], (comp) =>
          resolve({ ...comp.default, name: "NoticeList" })),
      meta: {
        title: "消息通知",
        keepAlive: true,
      },
    },
    {
      path: "/message/exportList",
      name: "exportList",
      component: (resolve) =>
        require(["@/pages/message/exportList"], (comp) =>
          resolve({ ...comp.default, name: "exportList" })),
      meta: {
        title: "导出记录",
        keepAlive: true,
      },
    },
    {
      path: "/ReportManager/PublicQuotationPages",
      name: "PublicQuotationPages",
      component: (resolve) =>
        require([
          "@/pages/FinancialManagement/ReportManager/PublicQuotationPages",
        ], (comp) =>
          resolve({ ...comp.default, name: "PublicQuotationPages" })),
      meta: {
        title: "报表明细",
        keepAlive: true,
      },
    },
    {
      path: "/wtl_test_setting/test",
      name: "wtl_test_setting",
      component: (resolve) =>
        require(["@/pages/BusinessOrder/WaybillManage/wtl_test_setting/test"], (
          comp
        ) => resolve({ ...comp.default, name: "wtl_test_setting" })),
      meta: {
        title: "测试配置表格",
        keepAlive: true,
      },
    },
  ],
};
